import { NavLink, Outlet, useParams } from 'react-router-dom'
import { useProject } from './useProject'
import { ErrorBanner, Loading, PageHeader, Tag } from '../../components/ui'

const TABS: Array<{ to: string; label: string; end?: boolean }> = [
  { to: '', label: 'Dashboard', end: true },
  { to: 'materials', label: 'Materials' },
  { to: 'attendance', label: 'Attendance' },
  { to: 'daily-reports', label: 'Daily Reports' },
  { to: 'bills', label: 'Bills' },
  { to: 'payments', label: 'Payments' },
  { to: 'expenses', label: 'Expenses' },
  { to: 'photos', label: 'Photos' },
  { to: 'accounts', label: 'Accounts' },
]

export function ProjectDetailLayout() {
  const { projectId } = useParams<{ projectId: string }>()
  const { data, isLoading, isError, error } = useProject(projectId)

  if (isLoading) return <Loading />
  if (isError) return <ErrorBanner error={error} />
  if (!data) return null

  return (
    <div>
      <PageHeader
        title={data.name}
        subtitle={data.address ?? data.location ?? undefined}
        actions={data.status ? <Tag>{data.status}</Tag> : undefined}
      />
      <nav className="border-b border-surface-700 mb-6 flex gap-1 overflow-x-auto">
        {TABS.map((t) => (
          <NavLink
            key={t.label}
            to={t.to}
            end={t.end}
            className={({ isActive }) =>
              `px-3 py-2 text-sm border-b-2 -mb-px whitespace-nowrap ${
                isActive
                  ? 'border-accent-500 text-accent-400'
                  : 'border-transparent text-surface-400 hover:text-surface-100'
              }`
            }
          >
            {t.label}
          </NavLink>
        ))}
      </nav>
      <Outlet />
    </div>
  )
}
